export const toggleFullScreen = () => {
  let ret = false;
  try {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen();
      ret = true;
    } else if (document.exitFullscreen) {
      document.exitFullscreen();
      ret = false;
    }
  } catch (err) {
    console.error('full screen 전환 중 오류', err);
  }
  return ret;
};
